<script setup lang="ts">
import Button from '@clovyr/bed/components/controls/Button.vue';
import { UserAPI } from '@clovyr/pollen/user';

import FormField from '@/components/blocks/FormField.vue';
import Modal from '@/components/elements/Modal.vue';
import { useEventBus } from '@/stores/event_bus';

const props = defineProps<{
  appName: string;
  appId: string;
}>();

const { eventBus } = useEventBus();

const email = ref('');
const emit = defineEmits(['close', 'submit']);

function closeModal() {
  emit('close');
}

function submitEmail() {
  void new UserAPI().notifyMe({
    appID: props.appId,
    appName: props.appName,
    email: email.value,
  });
  eventBus.emit('toast:show', {
    message: `We'll notify you at ${email.value} when ${props.appName || 'this app'} is available.`,
    type: 'success',
    duration: 4000,
  });
  closeModal();
  email.value = '';
}
</script>

<template>
  <Modal class="sub-modal" theme="transparent" size="narrow" @close="closeModal" max-on-mobile>
    <template #body>
      <div class="notify-modal">
        <h2 class="notify-modal__heading">Notify Me</h2>
        <p class="notify-modal__desc">
          Enter your email address to be notified when
          <strong class="notify-modal__app-name">{{ props.appName || 'this app' }}</strong>
          is available.
        </p>
        <form @submit.prevent="submitEmail">
          <FormField
            name="email"
            label="Email address"
            v-model="email"
            type="email"
            required
            class="notify-modal__input"
          />
          <Button type="submit" class="notify-modal__submit" reversed> Notify Me </Button>
        </form>
      </div>
    </template>
  </Modal>
</template>

<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';

.notify-modal__heading {
  margin-bottom: 1rem;
}

.notify-modal__desc {
  margin-bottom: 2rem;
}

.notify-modal__app-name {
  font-size: 16px;
  color: colors.color(action, primary);
}

.notify-modal__input {
  margin-bottom: 1.5rem;
}

.notify-modal__submit {
  width: 100%;
  margin-top: 0.5rem;
}
</style>
